import React from 'react';

export const ListingsHeader: React.FC<{
  view: 'grid' | 'list';
  onView: (v: 'grid' | 'list') => void;
}> = ({ view, onView }) => (
  <div className="mb-6">
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Listings</h1>
        <p className="mt-1 text-sm text-gray-500">Manage and monitor all entity types</p>
      </div>
      <div className="flex space-x-4">
        <div className="flex border rounded-lg overflow-hidden">
          {(['list', 'grid'] as const).map((v) => (
            <button
              key={v}
              onClick={() => onView(v)}
              className={`px-4 py-2 capitalize ${
                view === v ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
            >
              {v}
            </button>
          ))}
        </div>
      </div>
    </div>
  </div>
);
